import React, { useMemo } from "react";
import { generateColor, getInitials } from "../enums";

interface UserAvatarProps {
  name?: string;
  theme?: "light" | "dark";
  showName?: boolean;
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  theme = "light",
  showName = true,
  className = "",
}) => {
  const safeName = name || "";
  const initials = useMemo(() => getInitials(safeName), [safeName]);
  const backgroundColor = useMemo(
    () => generateColor(safeName, theme === "dark"),
    [safeName, theme]
  );

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <div
        className={`tw-flex tw-items-center tw-justify-center tw-size-8 tw-text-label-sm tw-rounded-full tw-font-medium tw-text-gray-700 ${className}`}
        style={{ backgroundColor }}>
        {initials}
      </div>
      {showName && <span>{safeName}</span>}
    </div>
  );
};

export default UserAvatar;
